import { api } from "./apiConfig";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

const publicApi = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
});

export const searchAddresses = async (query) => {
  const { data } = await api.get("/map/address", {
    params: { address: query },
  });
  return data.map((result) => ({
    id: result.place_id,
    name: result.description,
  }));
};

export const searchRegions = async (query) => {
  const { data } = await api.get("/map/regions", {
    params: { address: query },
  });
  return data.map((result) => ({
    id: result.place_id,
    name: result.description,
  }));
};

export const searchPublicAddresses = async (query, bookingPageSlug, searchBias = null) => {
  const params = { address: query };
  if (bookingPageSlug) {
    params.slug = bookingPageSlug;
  }
  if (searchBias) {
    params.location = searchBias;
  }

  const { data } = await publicApi.get("/api/public/map/address", {
    params,
  });
  return data.map((result) => ({
    id: result.place_id,
    name: result.description,
  }));
};

